$(function () {
    // #refonte timeline : le calendrier (bootstrap-datepicker) doit être localisé
    // selon la langue de l'app (en/fr). La locale fr est déjà chargée par base.html.twig
    // (bootstrap-datepicker.fr.min.js) ; on ne l'active que si ses libellés sont
    // effectivement présents, sinon repli sur 'en' (défaut intégré).
    var _locale = (document.documentElement.lang
        || (window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/) || [])[1]
        || 'en').toLowerCase();
    var _dpLang = ($.fn.datepicker && $.fn.datepicker.dates && $.fn.datepicker.dates[_locale]) ? _locale : 'en';

    $('.datepicker').datepicker({
        format: 'dd/mm/yyyy',
        language: _dpLang,
        autoclose: true,
        todayHighlight: true
    });

    function updateCheckList(id, isChecked, dateFrom, dateTo) {
        const studentId = $('#student-check-list').val();
        $.ajax({
            url: Routing.generate('service_student_checklist_update'),
            method: 'POST',
            data: {
                id: id,
                isChecked: isChecked,
                dateFrom: dateFrom,
                dateTo: dateTo,
                studentId: studentId,
            },
            success: function (response) {
                console.log(response.message);
                if (response.visaStateChanged == true) {
                    window.location.reload();
                }
            },
            error: function (xhr) {
                console.error(xhr.responseText);

                // Refus serveur (ex: dossier EEF vs commentaire) : on annule le cochage
                // et on affiche le message renvoyé
                const serverMessage = xhr.responseJSON && xhr.responseJSON.message;
                $(`#student_data_check_list_item_${id}`).prop('checked', !isChecked);

                if (serverMessage) {
                    if (window.toastr) {
                        toastr.options = { closeButton: true, timeOut: 5000 };
                        toastr.error(serverMessage);
                    } else {
                        alert(serverMessage);
                    }
                }
            }
        });
    }

    function handleChecklistUpdate() {
        const id = $(this).attr('id').replace(/(student_data_check_list_item_|student_data_check_list_date_from_|student_data_check_list_date_to_)/, '');
        const isChecked = $(`#student_data_check_list_item_${id}`).is(':checked'); // Get the checkbox state
        const dateFrom = $(`#student_data_check_list_date_from_${id}`).val();
        const dateTo = $(`#student_data_check_list_date_to_${id}`).val();
        updateCheckList(id, isChecked, dateFrom, dateTo);
    }

    $('.service-check-list .form-group input[type="checkbox"]').on('change', handleChecklistUpdate);
    $('.service-check-list .date-range-group input.datepicker, .date-range input.datepicker').on('change', handleChecklistUpdate);
});